import type { FirmDocumentFileActionReference } from 'pages/Documents/FirmDocuments/components/FirmDocumentFileActions';
import { getDocumentReferenceFileName } from 'pages/Documents/utilities/documentReferenceSorting';
import type { FirmDocumentDownloadTarget } from 'services/hooks/documents';

export const getFirmDocumentDownloadTarget = (
  documentReference: FirmDocumentFileActionReference,
  firmId?: number | null
): FirmDocumentDownloadTarget | null => {
  const fileId = documentReference.file.id;

  if (!fileId) {
    return null;
  }

  return {
    fileId,
    fileName: getDocumentReferenceFileName(documentReference),
    firmId,
  };
};
